import {Component, EventEmitter, inject, Output} from '@angular/core';
import {FormFieldComponent} from "../../shared/components/form-field/form-field.component";
import {MatButton} from '@angular/material/button';
import {MsgService} from '../../shared/service/msg.service';

@Component({
  selector: 'app-troca-senha',
  standalone: true,
  imports: [
    FormFieldComponent,
    MatButton
  ],
  templateUrl: './troca-senha.component.html',
  styleUrl: './troca-senha.component.css'
})
export class TrocaSenhaComponent {

  loginSenhas: loginSenhas = new loginSenhas();
  @Output() envioSenha = new EventEmitter<string>();

  private readonly msgService = inject(MsgService);

  redefinirSenha(){
    if(this.loginSenhas.senha !== this.loginSenhas.confirmacaoSenha){
      this.msgService.msgAdvertencia('Senhas divergentes');
    }
    else{
      this.envioSenha.emit(this.loginSenhas.senha);
    }
  }

}

export class loginSenhas{
  senha?: string;
  confirmacaoSenha?: string;
}
